import { PointOfDeliveryLoadEffects } from '../../../../effects/point-of-delivery-effects/pod-load-effects/point-of-delivery-load.effects';
import { JobsiteLoadAddressEffects } from '../../../../effects/jobsite-effects/jobsite-load-address-effects/jobsite-load-address.effects';
import { JobsiteLoadEffects } from '../../../../effects/jobsite-effects/jobsite-load-effects/jobsite-load.effects';
import { JobsiteLoadSalesAreaEffects } from '../../../../effects/jobsite-effects/jobsite-load-sales-area-effects/jobsite-load-address.effects';
import { JobsiteRenderMapEffects } from '../../../../effects/jobsite-effects/jobsite-render-map-effects/jobsite-render-map.effects';
import { ILocationConfigUnit } from '../../../../models/location-config.interface';
import { ILocationMapState } from '../../../../reducers/location-map-reducer/location-map.reducer';
import { JobsiteLoadAddressCommand } from '../../../../services/commands/jobsite/jobsite-load-address.command';
import { JobsiteLoadSalesAreaCommand } from '../../../../services/commands/jobsite/jobsite-load-sales-area.command';
import { JobsiteSetCommand } from '../../../../services/commands/jobsite/jobsite-set.command';
import { PointOfDeliveryLoadAddressCommand } from '../../../../services/commands/point-of-delivery/pod-load-address.command';
import { PointOfDeliveryLoadSalesAreaCommand } from '../../../../services/commands/point-of-delivery/pod-load-sales-area.command';
import { PointOfDeliverySetCommand } from '../../../../services/commands/point-of-delivery/pod-set.command';
import { LocationElements } from '../../../location-element';
import { PointOfDeliveryLoadAddressEffects } from '../../../../effects/point-of-delivery-effects/pod-load-address-effects/point-of-delivery-load-address.effects';
import { PointOfDeliveryRenderMapEffects } from '../../../../effects/point-of-delivery-effects/pod-render-map-effects/point-of-delivery-render-map.effects';
import { PointOfDeliveryLoadSalesAreaEffects } from '../../../../effects/point-of-delivery-effects/pod-load-sales-area/point-of-delivery-load-sales-area.effects';
import { PurchaseOrderSetCommand } from '../../../../services/commands/purchase-order/purchase-order-set.command';
import { PurchaseOrderMandatoryEffects } from '../../../../effects/purchase-order-effects/purchase-order-mandatory.effects';
import { CmxMapConfig } from '@ordersnproducts/modules/shared/models/cmx-map-config/cmx-map-config';
import { MAP_ADDRESS_TYPES } from '@ordersnproducts/modules/shared/constants/map-address-types';
import { SpecialInstructionsSetCommand } from '../../../../services/commands/special-instructions/special-instructions-set.command';

export const delivery: { fields: ILocationConfigUnit[]; mapConfig: ILocationMapState } = {
    fields: [
        {
            name: LocationElements.JOBSITE,
            visible: true,
            disabled: false,
            required: true,
            onChange: [JobsiteSetCommand, JobsiteLoadAddressCommand, JobsiteLoadSalesAreaCommand],
            dynamicEffects: [
                JobsiteLoadEffects,
                JobsiteLoadAddressEffects,
                JobsiteRenderMapEffects,
                JobsiteLoadSalesAreaEffects,
            ],
        },
        {
            name: LocationElements.POINT_OF_DELIVERY,
            visible: true,
            disabled: false,
            required: true,
            onChange: [PointOfDeliverySetCommand, PointOfDeliveryLoadAddressCommand, PointOfDeliveryLoadSalesAreaCommand],
            dynamicEffects: [
              PointOfDeliveryLoadEffects,
              PointOfDeliveryLoadAddressEffects,
              PointOfDeliveryRenderMapEffects,
              PointOfDeliveryLoadSalesAreaEffects,
            ],
          },
          {
            name: LocationElements.PURCHASE_ORDER,
            visible: true,
            disabled: false,
            required: false,
            onChange: [PurchaseOrderSetCommand],
            dynamicEffects: [PurchaseOrderMandatoryEffects],
          },
          {
            name: LocationElements.SPECIAL_INSTRUCTION,
            label: 'views.review.special_instructions',
            visible: true,
            disabled: false,
            required: false,
            onChange: [SpecialInstructionsSetCommand],
          },
    ],
    mapConfig: {
        showMap: true,
        config: new CmxMapConfig(null, MAP_ADDRESS_TYPES.POINT_OF_DELIVERY),
      },
};
